module.exports = __webpack_public_path__ + "img/cube (1).0cf3606b.png";